import React, { useState } from "react";
import { toast } from "react-toastify";
import http from "../services/http";
import config from "../config/api.json";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle phone number formatting
    if (name === "phone") {
      const digits = value.replace(/\D/g, "");
      let formattedValue = digits;
      
      if (digits.length >= 1) {
        formattedValue = "(" + digits.substring(0, 3);
      }
      if (digits.length >= 4) {
        formattedValue += ") " + digits.substring(3, 6);
      }
      if (digits.length >= 7) {
        formattedValue += "-" + digits.substring(6, 10);
      }
      
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const reqBody = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      };

      const url = `${config.apiUrl}/contact`;
      await http.post(url, reqBody);

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      toast.success("Success! Your message has been sent.");
    } catch (error) {
      if (error.response) {
        toast.error(
          error.response.data.message ||
            "Failed to send message. Please try again."
        );
      } else {
        toast.error("Unexpected error. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact" id="4">
      <h1>Contact Us</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
          maxLength={50}
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
          maxLength={255}
        />
        <input
          type="tel"
          name="phone"
          placeholder="Your Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
          maxLength={14}
        />
        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          maxLength={1000}
        />
        <button type="submit" className="cta-button" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
};

export default Contact;
